module.exports = __webpack_public_path__ + "img/SketchPng72cfdb3aaca62b99245ed001de330cac28cec70491300bdade82e2a5de83b753.26729413.png";